(function () {
  // Prevent double-mount
  if (window.__DTB_MOUNTED__) return;
  window.__DTB_MOUNTED__ = true;

  const DEFAULTS = {
    thresholds: [900, 1300, 1800],
    discounts: [5, 10, 15],
    labels: ["5% Off", "10% Off", "15% Off"],
    title: "Unlock discounts",
    subtitle: "Add items to see your progress.",
    panelTitle: "Your discount progress",
    hideWhenEmpty: false,
    openByDefault: false
  };

  function parseCSVNumbers(str) {
    return (str || "")
      .split(",")
      .map((s) => Number(s.trim()))
      .filter((n) => Number.isFinite(n));
  }

  function parseCSVStrings(str) {
    return (str || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  function mountFromConfig(config) {
    const cfg = { ...DEFAULTS, ...config };

    // Normalize tiers
    const tierCount = Math.min(cfg.thresholds.length, cfg.discounts.length);
    let tiers = cfg.thresholds.slice(0, tierCount).map((t, i) => ({
      threshold: t,
      discount: cfg.discounts[i],
      label: (cfg.labels && cfg.labels[i]) ? cfg.labels[i] : `${cfg.discounts[i]}% Off`
    })).sort((a, b) => a.threshold - b.threshold);

    if (!tiers.length) return;

    const moneyFormat = cfg.moneyFormat || "${{amount}}";

    function formatMoneyFromCents(cents) {
      const val = cents / 100;
      const noDecimals = moneyFormat.includes("amount_no_decimals");
      let amount = noDecimals ? Math.round(val).toString() : val.toFixed(2);

      if (moneyFormat.includes("with_comma_separator")) {
        const parts = amount.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        amount = parts.join(",");
      } else {
        const parts = amount.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        amount = parts.join(".");
      }

      return moneyFormat
        .replace("{{amount}}", amount)
        .replace("{{amount_no_decimals}}", amount.split(/[.,]/)[0])
        .replace("{{amount_with_comma_separator}}", amount)
        .replace("{{amount_no_decimals_with_comma_separator}}", amount.split(/[.,]/)[0]);
    }

    // Create DOM
    const root = document.createElement("div");
    root.id = "dtb-sitewide-root";
    root.style.cssText =
      "position:fixed;left:0;right:0;bottom:60px;z-index:999999999;pointer-events:none;font-family:inherit;padding-bottom:env(safe-area-inset-bottom);";

    root.innerHTML = `
      <button id="closeButton" style="
    background-color: #000;
    color: white;
    border: none;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    font-size: 18px;
    z-index:999999;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
">
    ×
</button>
      <button id="dtb-collapsed" type="button" aria-expanded="false"
        style="pointer-events:auto;width:min(960px,calc(100% - 24px));margin:0 auto 12px;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border-radius:14px;border:1px solid rgba(0,0,0,.08);background:rgba(255,255,255,.92);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);box-shadow:0 10px 30px rgba(0,0,0,.10);cursor:pointer;">
        <span style="display:flex;flex-direction:column;gap:2px;text-align:left;min-width:0;">
          <span id="dtb-title" style="font-weight:700;font-size:14px;line-height:1.2;color:rgba(0,0,0,.85);"></span>
          <span id="dtb-meta" style="font-size:13px;color:rgba(0,0,0,.60);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60vw;"></span>
        </span>
        <span style="display:flex;align-items:center;gap:10px;flex-shrink:0;">
          <span id="dtb-badge" style="display:inline-flex;align-items:center;justify-content:center;height:28px;padding:0 10px;border-radius:999px;background:rgba(0,0,0,.06);font-weight:700;font-size:13px;color:rgba(0,0,0,.80);">—</span>
          <span id="dtb-chev" aria-hidden="true" style="font-size:14px;opacity:.7;transform:translateY(1px);">▴</span>
        </span>
      </button>

      <div id="dtb-panel" hidden
        style="pointer-events:auto;width:min(960px,calc(100% - 24px));margin:0 auto 12px;border-radius:16px;border:1px solid rgba(0,0,0,.10);background:rgba(255,255,255,.97);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 18px 60px rgba(0,0,0,.18);overflow:hidden;">
        <div style="padding:14px 14px 12px;">
          <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:12px;">
            <div>
              <div style="font-weight:800;font-size:15px;color:rgba(0,0,0,.88);margin-bottom:2px;">${escapeHtml(cfg.panelTitle)}</div>
              <div id="dtb-subtitle" style="font-size:13px;color:rgba(0,0,0,.62);"></div>
            </div>
            <button id="dtb-close" type="button" aria-label="Close"
              style="border:0;background:rgba(0,0,0,.06);border-radius:10px;width:34px;height:34px;cursor:pointer;font-size:16px;line-height:34px;">✕</button>
          </div>

          <div id="dtb-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"
            style="position:relative;height:10px;border-radius:999px;background:rgba(0,0,0,.08);overflow:hidden;">
            <div id="dtb-fill" style="height:100%;width:0%;border-radius:999px;background:rgba(0,0,0,.72);transition:width 320ms ease;"></div>
          </div>

          <div id="dtb-tiers" style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin-top:12px;"></div>

          <div style="margin-top:12px;font-size:13px;color:rgba(0,0,0,.65);" id="dtb-footer"></div>
        </div>
      </div>
    `;

    document.body.appendChild(root);

    // Responsive tiers grid
    const tiersEl = root.querySelector("#dtb-tiers");
    const mobileMQ = window.matchMedia("(max-width: 640px)");
    function applyGrid() {
      tiersEl.style.gridTemplateColumns = mobileMQ.matches ? "1fr" : "repeat(3,minmax(0,1fr))";
    }
    applyGrid();
    mobileMQ.addEventListener?.("change", applyGrid);

    // Elements
    const collapsedBtn = root.querySelector("#dtb-collapsed");
    const panel = root.querySelector("#dtb-panel");
    const closeBtn = root.querySelector("#dtb-close");
    const chev = root.querySelector("#dtb-chev");

    const titleEl = root.querySelector("#dtb-title");
    const metaEl = root.querySelector("#dtb-meta");
    const badgeEl = root.querySelector("#dtb-badge");
    const subtitleEl = root.querySelector("#dtb-subtitle");
    const fillEl = root.querySelector("#dtb-fill");
    const trackEl = root.querySelector("#dtb-track");
    const footerEl = root.querySelector("#dtb-footer");

    titleEl.textContent = cfg.title;
    metaEl.textContent = cfg.subtitle;

    function setOpen(open) {
      collapsedBtn.setAttribute("aria-expanded", open ? "true" : "false");
      panel.hidden = !open;
      chev.textContent = open ? "▾" : "▴";
      try { sessionStorage.setItem("dtb_sitewide_open", open ? "1" : "0"); } catch (e) {}
    }

    collapsedBtn.addEventListener("click", () => {
      const open = collapsedBtn.getAttribute("aria-expanded") === "true";
      setOpen(!open);
    });
    closeBtn.addEventListener("click", () => setOpen(false));

    // init open state
    let open = !!cfg.openByDefault;
    try {
      const saved = sessionStorage.getItem("dtb_sitewide_open");
      if (saved === "1") open = true;
      if (saved === "0") open = false;
    } catch (e) {}
    setOpen(open);

    function render(cartCents) {
      if (cfg.hideWhenEmpty && cartCents === 0) {
        root.style.display = "none";
        return;
      }
      root.style.display = "";

      const cartValue = cartCents / 100;

      let reachedIndex = -1;
      for (let i = 0; i < tiers.length; i++) {
        if (cartValue >= tiers[i].threshold) reachedIndex = i;
      }

      const hasNext = reachedIndex < tiers.length - 1;
      const currentDiscount = reachedIndex >= 0 ? tiers[reachedIndex].discount : 0;

      const last = tiers[tiers.length - 1].threshold;
      const pct = last ? Math.max(0, Math.min(100, (cartValue / last) * 100)) : 0;
      fillEl.style.width = pct.toFixed(2) + "%";
      trackEl.setAttribute("aria-valuenow", String(Math.round(pct)));

      tiersEl.innerHTML = tiers.map((tier, i) => {
        const reached = cartValue >= tier.threshold;
        const active = hasNext ? (i === reachedIndex + 1) : (i === reachedIndex);
        const icon = reached ? "✓" : "%";
        const top = `${formatMoneyFromCents(Math.round(tier.threshold * 100))} • ${tier.label}`;
        const bottom = reached
          ? "Unlocked"
          : `Spend ${formatMoneyFromCents(Math.max(0, Math.round((tier.threshold - cartValue) * 100)))} more`;

        const border = reached ? "rgba(0,0,0,.30)" : "rgba(0,0,0,.10)";
        const bg = reached ? "rgba(0,0,0,.04)" : "rgba(0,0,0,.02)";
        const iconBg = reached ? "rgba(0,0,0,.78)" : "rgba(0,0,0,.07)";
        const iconColor = reached ? "#fff" : "inherit";

        return `
          <div style="border:1px solid ${border};border-radius:14px;padding:10px;display:flex;gap:10px;align-items:center;background:${bg};${active ? "outline:2px solid rgba(0,0,0,.12);" : ""}">
            <div style="width:34px;height:34px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:${iconBg};font-weight:900;font-size:14px;color:${iconColor};">${icon}</div>
            <div style="min-width:0;display:flex;flex-direction:column;gap:2px;">
              <div style="font-size:13px;font-weight:800;color:rgba(0,0,0,.82);">${escapeHtml(top)}</div>
              <div style="font-size:12.5px;color:rgba(0,0,0,.60);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHtml(bottom)}</div>
            </div>
          </div>
        `;
      }).join("");

      if (hasNext) {
        const nextTier = tiers[reachedIndex + 1];
        const remaining = Math.max(0, Math.round((nextTier.threshold - cartValue) * 100));
        const msg = `Add ${formatMoneyFromCents(remaining)} more to unlock ${nextTier.discount}% off.`;
        subtitleEl.textContent = msg;
        metaEl.textContent = msg;
        badgeEl.textContent = currentDiscount ? `${currentDiscount}% off` : "No discount yet";
        footerEl.textContent = `Current cart: ${formatMoneyFromCents(cartCents)} • Current discount: ${currentDiscount}%`;
      } else {
        const maxTier = tiers[tiers.length - 1];
        const msg = `You’ve unlocked the maximum discount: ${maxTier.discount}% off.`;
        subtitleEl.textContent = msg;
        metaEl.textContent = msg;
        badgeEl.textContent = `${maxTier.discount}% off`;
        footerEl.textContent = `Current cart: ${formatMoneyFromCents(cartCents)} • Max discount unlocked`;
      }
    }

    async function refresh() {
      try {
        const res = await fetch("/cart.js", { credentials: "same-origin" });
        if (!res.ok) return;
        const cart = await res.json();
        const subtotal = (typeof cart.items_subtotal_price === "number") ? cart.items_subtotal_price : cart.total_price;
        render(subtotal || 0);
      } catch (e) {}
    }

    // Update hooks
    window.addEventListener("cart:updated", refresh);
    window.addEventListener("cart:refresh", refresh);
    document.addEventListener("cart:refresh", refresh);

    // Patch fetch/xhr for cart endpoints
    const shouldRefresh = (url) => {
      if (!url) return false;
      const u = String(url);
      return u.includes("/cart/add") || u.includes("/cart/change") || u.includes("/cart/update") || u.includes("/cart/clear");
    };

    if (window.fetch && !window.__DTB_FETCH_PATCHED__) {
      const origFetch = window.fetch;
      window.fetch = function () {
        const p = origFetch.apply(this, arguments);
        try { if (shouldRefresh(arguments[0])) p.then(() => setTimeout(refresh, 150)); } catch (e) {}
        return p;
      };
      window.__DTB_FETCH_PATCHED__ = true;
    }

    if (window.XMLHttpRequest && !window.__DTB_XHR_PATCHED__) {
      const origOpen = XMLHttpRequest.prototype.open;
      const origSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__dtbUrl = url;
        return origOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        try {
          this.addEventListener("loadend", () => {
            if (shouldRefresh(this.__dtbUrl)) setTimeout(refresh, 150);
          });
        } catch (e) {}
        return origSend.apply(this, arguments);
      };

      window.__DTB_XHR_PATCHED__ = true;
    }

    refresh();
    setInterval(refresh, 8000);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // Read config from the script tag's data-* attributes (set in theme.liquid)
  function boot() {
    const el = document.querySelector('script[data-dtb-config="1"]');
    if (!el) return;

    const thresholds = parseCSVNumbers(el.dataset.thresholds);
    const discounts = parseCSVNumbers(el.dataset.discounts);
    const labels = parseCSVStrings(el.dataset.labels);

    mountFromConfig({
      moneyFormat: el.dataset.moneyFormat,
      thresholds: thresholds.length ? thresholds : undefined,
      discounts: discounts.length ? discounts : undefined,
      labels: labels.length ? labels : undefined,
      title: el.dataset.title || undefined,
      subtitle: el.dataset.subtitle || undefined,
      panelTitle: el.dataset.panelTitle || undefined,
      hideWhenEmpty: el.dataset.hideWhenEmpty === "true",
      openByDefault: el.dataset.openByDefault === "true"
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
